export const sendYandexMetricaEvent = (...args: any[]) => {
	if (typeof window === 'undefined') return
	if (typeof window.ym !== 'function') return

	window.ym(`10760449`, 'reachGoal', ...args)
}
